<div style="width: 80%; max-width: 800px;">
  <div>
    <h1 style="font-weight: 600;">Veröffentlichung und Lizenzierung des Produkts</h1>
    <form #form="ngForm">
      <!-- Origin_Listing -->
      <div *ngIf="activeListing" style="margin-bottom: 24px;">
        <h3>Verwendetes Abonnement</h3>
        <mat-card class="license-card" style="padding: 16px 20px; box-sizing: border-box;">
          <div class="card-header">
            <div class="package-info">
              <div class="package-number">{{ activeListing.originListing.packageName }}</div>
              <!-- <div class="date-range">{{ activeListing.originListing.currentUsage }} / {{ activeListing.originListing.listingCapacity }} Verwendete Lizenzen</div> -->
            </div>
          </div>

          <div class="expand-icon">
            <div style="font-size: 16px;">{{ product.name }}</div>
            <button style="width: 204px; justify-self: left" class="btn_red" mat-raised-button (click)="removeEntry()">
              Lizenzzuordnung entfernen
            </button>
          </div>
        </mat-card>

        <!-- Prio_Listing -->
        <mat-card *ngIf="activeListing.prioListing !== null &&
         (isPrioritized ||
          activeListing.prioListing.currentUsage < activeListing.prioListing.listingCapacity)" class="license-card"
          style="padding: 16px 20px; box-sizing: border-box;">
          <div class="card-header">
            <div class="package-info">
              <div class="package-number">Priorisierung</div>
              <!-- <div class="date-range">{{ activeListing.prioListing.currentUsage }} / {{ activeListing.prioListing.listingCapacity }} Verwendete Lizenzen</div> -->
            </div>
          </div>

          <div class="expand-icon">
            <div>{{ product.name }}</div>
            <button style="width: 204px; justify-self: left" class="btn_red" mat-raised-button (click)="isPrioritized
                ? removePriorization(activeListing.originListing.subscriptionId) 
                : addPriorization(activeListing.originListing.subscriptionId)">
              {{ isPrioritized ? 'Nicht mehr priorisieren' : 'Priorisieren' }}
            </button>
          </div>
        </mat-card>
      </div>

      <div>
        <h3 style="margin-bottom: 8px;">Meine Abonnements</h3>
        <mat-form-field style="width: 100%">
          <mat-select [ngModel]="selectedGrantOptions" name="authGrantTypes" (ngModelChange)="onGrantSelection($event)"
            placeholder="Verfügbare Abonnements" panelClass="custom-select-panel">
            <mat-option *ngFor="let option of productFromListing"
              [value]="option.originListing.subscriptionId"><strong>{{ option.originListing.packageName }}</strong>
              &nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;{{
              option.originListing.currentUsage}}/{{option.originListing.listingCapacity}} Verwendete
              Lizenzen</mat-option>
          </mat-select>
        </mat-form-field>
        <br />
      </div>

      <div class="add-abo-btn">
        <app-hexagon-button-text-icon [text]="'Neues Abonnement'" [icon]="'/assets/img/hochladen.png'"
          (click)="showTarifeSelectionDialog()">
        </app-hexagon-button-text-icon>
      </div>
      <div style="margin-top: 20px;" class="grid">
        <button mat-raised-button class="btn_green" [disabled]="selectedGrantOptions === ''" (click)="onSave()">
          {{ activeListing ? 'Speichern' : 'Veröffentlichen' }}
        </button>
        <button mat-raised-button class="btn_red" (click)="onCancel()">
          Abbrechen
        </button>
      </div>
    </form>
  </div>
</div>
<div *ngIf="loading" class="loading-overlay-spinner">
  <mat-spinner></mat-spinner>
</div>